import { NoteTypeTag } from "@/common/NoteTypeTag";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import { useRuntimeImage } from "@/entities/runtime-image";
import { PersonRecord } from "@/common/PersonRecord";
import { CommitmentFlag } from "@/common/CommitmentFlag";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import type { FC } from "react";
import type { NotesListCardHeaderProps } from "../../model";
import { StatusMenuDropdown } from "../StatusMenuDropdown/StatusMenuDropdown";
import { StatusText } from "../StatusText";
import styles from "./styles.module.scss";

export const NotesListCardHeader: FC<NotesListCardHeaderProps> = ({
  cardData,
  onStatusChange,
  onAvatarClick = () => "",
  selectedNotesIds,
}) => {
  const { getRuntimeImageURL } = useRuntimeImage();
  const { person } = cardData;
  const isShowStatus =
    cardData.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT ||
    cardData.noteType.name === DEFAULT_NOTE_TYPES.DEFAULT_IDEA;

  return (
    <div className={styles.header}>
      <div className={styles["header-top"]}>
        <div className={styles["note-types"]}>
          <NoteTypeTag noteType={cardData.noteType.name} status={cardData.status} />
          {isShowStatus && cardData.status && <StatusText noteStatus={cardData.status} />}
        </div>
        {isShowStatus && <StatusMenuDropdown cardData={cardData} onStatusChange={onStatusChange} />}
      </div>
      <div className={styles["header-person"]}>
        <PersonRecord
          onAvatarClick={() => onAvatarClick(cardData)}
          avatar={getRuntimeImageURL({ fileId: person?.avatarFile?.fileId ?? "" })}
          group={person?.group ?? ""}
          name={handleFullName(person?.firstName, person?.lastName, person?.middleName)}
          title={person?.title ?? ""}
          selected={!!selectedNotesIds.find((id) => id === cardData.id)}
        />

        <CommitmentFlag flag={cardData.direction} isShowFlag={false} />
      </div>
    </div>
  );
};
